import { render, staticRenderFns } from "./CompliancePublic.vue?vue&type=template&id=5ab245f5&scoped=true"
import script from "./CompliancePublic.vue?vue&type=script&lang=js"
export * from "./CompliancePublic.vue?vue&type=script&lang=js"
import style0 from "./CompliancePublic.vue?vue&type=style&index=0&id=5ab245f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab245f5",
  null
  
)

export default component.exports